<template>
  <ComponentLoader
    class="contest-page"
    :class="{
      'dark-mode': !this.isCDPR,
      'is-cdpr': this.isCDPR,
    }"
    :components="getSpecificPage"
  />
</template>

<script>
import { mapGetters } from "vuex";
import ComponentLoader from "../components/ComponentLoader.vue";

export default {
  name: "contest-page",
  components: {
    ComponentLoader,
  },
  computed: {
    ...mapGetters(["getPagesEN", "getPagesDE", "getLanguage"]),

    getSpecificPage() {
      const page =
        this.getLanguage == "de-DE" ? this.getPagesDE : this.getPagesEN;

      const specificPage = page.find((page) => {
        const pageSlug =
          page.fields.slug !== "/" ? "/" + page.fields.slug : "/";
        return pageSlug == this.$route.path;
      });

      return specificPage?.fields?.reference;
    },

    isCDPR() {
      return window.location.href.includes("test-page");
    },
  },
  mounted() {
    this.setupStyles();
  },
  methods: {
    setupStyles() {
      let bg = "var(--sewcase-nb-purple)";
      let navItem = "var(--sewcase-white)";
      let navItemInner = "var(--sewcase-black)";

      if (!this.isCDPR) {
        this.styleElement = document.createElement("style");
        this.styleElement.textContent = `
          body { 
            background-color: ${bg}; 
          }
          nav {
            background-color: ${bg}; 
          }
          nav a {
            color: ${navItem};
          }
          .nav-lang-switch-item {
            color: ${navItem};
          }
          .nav-item .nav-sub-item-container a {
            color: ${navItemInner};
          }
        `;
        this.styleElement.id = "contest-style";

        document.head.appendChild(this.styleElement);
      }
    },
  },
  beforeUnmount() {
    const styleElement = document.getElementById("contest-style");
    if (styleElement && styleElement.parentNode) {
      styleElement.parentNode.removeChild(styleElement);
    }
  },
};
</script>

<style lang="scss">
.contest-page {
  padding-bottom: $spacing-lg;

  hr {
    border-color: #000000;
    border-width: 2px;
    margin: 32px 0;
  }
  p {
    line-height: 1.3;
  }

  &.is-cdpr {
    .register-card {
      background: $sewcase-white;

      .register-heart {
        background: $sewcase-black;

        .pixel-heart {
          background-color: $cdpr-red;

          &:before,
          &:after {
            background-color: $cdpr-red;
          }
        }
      }

      .register-content {
        color: $sewcase-black;
      }

      .register-button:not(.register-button--disabled) {
        background: $cdpr-red;
        color: $sewcase-white;
      }
    }

    .register-section .richtext-wrapper:before {
      background: $sewcase-black;
    }

    .custom-checkbox {
      p {
        color: $sewcase-black;
      }
      input:checked ~ .checkmark {
        background-color: $cdpr-red;
      }
      a {
        color: $cdpr-red;
      }
    }
    .nb-card-wrapper {
      .nb-card-role {
        color: $cdpr-red;
        text-shadow: 4px 3px $sewcase-white;

        &:before {
          background-color: $sewcase-white;
        }
      }
      .nb-card-content {
        background: $sewcase-white;
      }
    }
    .swiper-pagination {
      background: $cdpr-red;

      .swiper-pagination-bullet {
        transition: 0.2s ease;
        &.swiper-pagination-bullet-active {
          width: 20px;
          border-radius: 4px;
        }
      }
    }
  }

  &.dark-mode {
    .nb-card-content,
    .nb-card-wrapper .nb-card-content,
    .richtext-wrapper {
      padding-bottom: 0;

      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p,
      strong {
        color: $sewcase-white;
      }

      .nb-card-url {
        color: $sewcase-black;
      }
    }

    .social-media-wrapper .social-media-item:hover {
      background-color: $sewcase-white;
    }

    .text-image-container {
      .text-image-content {
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        p,
        strong {
          color: $sewcase-white;
        }

        a:hover {
          color: $sewcase-nb-green;
        }
      }
    }

    .text-image-container-nb {
      .text-image-content {
        background-color: $sewcase-nb-blue;

        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        p,
        strong {
          color: $sewcase-white;
        }

        a:hover {
          color: $sewcase-nb-green;
        }
      }
    }

    .hero-image-sidebar-sub-headline--neubrutalism {
      text-shadow: 6px 5px $sewcase-nb-purple;
    }

    .nav-sub-item-container .nav-item {
      color: $sewcase-black;
    }

    .nb-card-wrapper .nb-card-url {
      color: $sewcase-white;
    }

    .accordion__container {
      border-radius: 8px;
      border-width: 3px;
      position: relative;

      &:before {
        content: "";
        position: absolute;
        background: $sewcase-black;
        border-radius: $border-radius-sm;
        right: -20px;
        bottom: -20px;
        width: 100%;
        height: 100%;
        transition: all 0.2s ease;
        z-index: -1;
      }

      .accordion__headline {
        background: $sewcase-nb-purple;
        border-radius: 4px 4px 0 0;
        border-bottom: 3px solid $sewcase-black;
        color: $sewcase-white;

        .accordion__toggle {
          &:before,
          &:after {
            background: $sewcase-white;
          }
        }
      }
      .accordion__content {
        background: $sewcase-nb-purple;
        border-radius: 0 0 4px 4px;
        * {
          color: $sewcase-white;
        }
        a {
          color: $sewcase-secondary;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>
